import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { SearchComponent } from './search/search.component';
import { ResultsComponent } from './results/results.component';
import { ScatterChartComponent } from './scatter/scatter.component';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { ConcordanceComponent } from './concordance/concordance.component';
import { SummaryComponent } from './summary/summary.component';
import { NvD3Module } from 'ng2-nvd3';
import { AgeChartComponent } from './AgeChart/age.component';
import { MapComponent } from './map/map.component';

import * as d3 from 'd3';
import * as nvd3 from 'nvd3';

import { SpeakerService } from './speaker.service';
import { UserMsgService } from './user-msg.service';

import { AppRoutingModule } from './app-routing/app-routing.module';

import { IterateObjectPipe } from './iterate-object.pipe';
import { LeafletMapComponent } from './leaflet-map/leaflet-map.component';

import { LeafletModule } from '@asymmetrik/angular2-leaflet';
import { ActiveTabDirective } from './active-tab.directive';
import { LightboxModule } from 'angular2-lightbox';

import { DataTableModule, SliderModule, SharedModule, GMapModule, ChartModule, AccordionModule, DropdownModule, TabViewModule, FieldsetModule, CheckboxModule } from 'primeng/primeng';
import { LineChartComponent } from './line-chart/line-chart.component';
import { StudentComponent } from './student/student.component';
import { FusionbarComponent } from './fusionbar/fusionbar.component';


import { FlotModule } from 'ng2modules-flot';
import { StaticAboutComponent } from './static-about/static-about.component';
import { StaticContactComponent } from './static-contact/static-contact.component';

import { AgmCoreModule } from '@agm/core';

import { ChartsModule } from 'ng2-charts';
import { ChangeComponent } from './change/change.component';
import { WritingComponent } from './writing/writing.component';
@NgModule({
  declarations: [
    AppComponent,
    SearchComponent,
    ResultsComponent,
    BarChartComponent,
    ConcordanceComponent,
    IterateObjectPipe,
    LeafletMapComponent,
    ActiveTabDirective,
    LineChartComponent,
    StudentComponent,
    FusionbarComponent,
    StaticAboutComponent,
    StaticContactComponent,
    SummaryComponent,
    ScatterChartComponent,
    AgeChartComponent,
    MapComponent,
    ChangeComponent,
    WritingComponent
  ],
  imports: [
    BrowserModule,
    NvD3Module,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    AppRoutingModule,
    LeafletModule,
    DataTableModule,
    SharedModule,
    ChartModule,
    AccordionModule,
    BrowserAnimationsModule,
    DropdownModule,
    SliderModule,
    TabViewModule,
    FieldsetModule,
    CheckboxModule,
    LightboxModule,
    FlotModule,
    ChartsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDWGqNb-lXD4dNOn3qaBw0m_X5LRo6S0Uk'
    })
  ],
  providers: [SpeakerService, UserMsgService],
  bootstrap: [AppComponent]
})
export class AppModule { }




// WEBPACK FOOTER //
// /home/ingvars/BNC-Lab/front/src/app/app.module.ts